<template>
  <div class="input-wrapper">
    <!-- {{ createdDate }} -->
    <div class="timesheet-profile">
      <div class="inputwrapper">
        <v-label class="pb-1">Vacation(Hours)</v-label>
        <TextFieldComponent
          density="compact"
          placeholder="Vacation"
          v-model="vacationsForm.actual_hrs"
          @keydown="prevent($event)"
          @change="validateInput(vacationCode[0])"
          :showReadOnly="ptoForm.actual_hrs>0 || lopForm.actual_hrs>0"
        ></TextFieldComponent>
      </div>

      <div class="inputwrapper">
        <v-label class="pb-1">PTO(Hours)</v-label>
        <TextFieldComponent
          density="compact"
          placeholder="PTO"
          v-model="ptoForm.actual_hrs"
          @keydown="prevent($event)"
          @change="validateInput(vacationCode[1])"
          :showReadOnly="vacationsForm.actual_hrs>0 || lopForm.actual_hrs>0"
        ></TextFieldComponent>
      </div>

      <div class="inputwrapper">
        <v-label class="pb-1">LOP(Hours)</v-label>
        <TextFieldComponent
          density="compact"
          placeholder="LOP"
          v-model="lopForm.actual_hrs"
          @keydown="prevent($event)"
          @change="validateInput(vacationCode[2])"
          :showReadOnly="ptoForm.actual_hrs>0 || vacationsForm.actual_hrs>0"
        ></TextFieldComponent>
      </div>
    </div>

    <div style="display: flex; align-items: center">
      <button class="save" @click="saveData">SUBMIT</button>
    </div>
  </div>
</template>

<script>
import TextFieldComponent from "@/components/TextFieldComponent.vue";
import TimeSheetService from "@/api/service/TimeSheet/TimeSheetService";
import logicCondition from "@/api/logic/condition";
// import { values } from "core-js/core/dict";


export default {
  props: ["data","date","userDetails"],
  components: {
    TextFieldComponent,
  },
  data() {
    return {
      vacationCode: logicCondition.vacationCode || [],
      vacationsForm: {},
      ptoForm: {},
      lopForm: {},
      createdDate:null,
    };
  },
  watch: {
    userDetails(){
      if(this.userDetails){        
       this.getVacationData()
      }
    },
    date() {
      if (this.date) {
       this.createdDate =this.date
       this.getVacationData()
      }
    }
  },
  created(){
    this.setBasicData()
    this.createdDate = this.date
    this.getVacationData()
  },
  computed: {
    // activeField() {
    //   return Object.keys(this.formData).find((key) => this.formData[key]);
    // },
  },
  methods: {
    setBasicData(){
      this.vacationsForm = {
        code: logicCondition.vacationCode?.[0] || ''
      }
      this.ptoForm = {
        code: logicCondition.vacationCode?.[1] || ''
      }
      this.lopForm = {
        code: logicCondition.vacationCode?.[2] || ''
      }
    },
    async getVacationData(){
      if(this.userDetails  && this.createdDate){
        try {
          let res = await TimeSheetService.getVacationData({user_id:this.userDetails.id,date:this.createdDate})
          if(res && res.length>0){
            this.vacationsForm = this.setTheData(this.vacationsForm.code,res,this.vacationsForm)
            this.ptoForm = this.setTheData(this.ptoForm.code,res,this.ptoForm)
            this.lopForm = this.setTheData(this.lopForm.code,res,this.lopForm)
          }else{
            this.setBasicData()
          }
        } catch (exception) {
          console.error(exception,'error');
        }
      }
    },
    setTheData(code,value,data){
      console.log(code,' ###',value);
      let $data = value.filter(k=>k.code == code)
      if($data && $data.length>0){
        data.id = $data[0].id 
        data.actual_hrs = $data[0].actual_hrs
      }
      return data
    
    },
    // isFieldDisabled(field) {
    //   console.log(field)
    //   // return this.activeField && this.activeField !== field;
    // },
    prevent(e) {
      if (!/^\d*(\.\d{1,2})?$/.test(e.key) && e.key !== "Backspace") {
        e.preventDefault();
      }
    },
    async validateInput(field) {
      let obj = {}
      if(this.vacationsForm.code == field){
        obj = this.vacationsForm
      }
      else if(this.ptoForm.code == field){      
        obj = this.ptoForm
      }
      else {
        obj = this.lopForm
      }
      obj.resource_id = this.userDetails.id
      obj.entry_date = this.createdDate      
      let $obj = {...obj}
      $obj.actual_hrs = $obj.actual_hrs * 60
      await TimeSheetService.saveTheVacationData(obj)
      let data = obj.code == 'VAC'?this.vacationsForm : obj.code == 'PTA'? this.ptoForm :this.lopForm
      this.setTheData(obj.code,[obj],data)
      this.$emit('refresh-timesheet')
      
    },
    async saveData() {
  // if (!this.formData.vacation && !this.formData.pto && !this.formData.lop) {
  //   this.$store.dispatch("setSnackbar", {
  //     text: "Please enter at least one value",
  //     color: "error",
  //   });
  //   return;
  // }

  // const getTaskId = async (code) => {
  //   const task = await TaskService.findAll({ code });
  //   return task?.[0]?.id || null;
  // };

  // let data = {};
  // if (this.formData.vacation) {
  //   data = {
  //     task_id: await getTaskId("VAC"),
  //     actual_hrs: 480,
  //     billed_hrs: 480,
  //     createdDate:this.createdDate
  //   };
  // } else if (this.formData.lop) {
  //   data = {
  //     task_id: await getTaskId("LOP"),
  //     actual_hrs: this.formData.lop,
  //     billed_hrs: -this.formData.lop,
  //     createdDate:this.createdDate
  //   };
  // } else {
  //   data = {
  //     task_id: await getTaskId("PTA"),
  //     actual_hrs: this.formData.pto,
  //     billed_hrs: 0,
  //     createdDate:this.createdDate
  //   };
  // }

  // console.log(data ,'datatat')

  // await TimeSheetService.create(data);
  // this.$store.dispatch("setSnackbar", { text: "Saved Successfully" });

  // this.formData = { vacation: "", pto: "", lop: "" };
  // this.$emit("reload", true);
}

  },
};
</script>

<style scoped>
.input-wrapper {
  width: 60%;
  display: flex;
  gap: 1rem;
}

.timesheet-profile {
  display: flex;
  padding: 1rem 1rem;
  width: 100%;
  gap: 1rem;
  border-radius: 4px;
  border: 1px solid #d2d2d2;
  background-color: #ebf1f3;
}
.inputwrapper {
  width: 30%;
}
.save {
  background-color: #1258ab;
  border: 1px solid #d2d2d2;
  color: #ffffff;
  font-size: 0.875rem;
  font-weight: 700;
  height: fit-content;
  padding: 0.5rem 2rem;
  border-radius: 4px;
}
>>> .v-input__details {
  display: contents;
}
</style>
